import React from 'react';
import { useMemo } from 'react';

const MultiplePlayersBar = (props) => {

    const {
        homeTeamPlayers,
        awayTeamPlayers,
        selectedPlayers,
        setSelectedPlayers,
        selectedPlayersTeam,
        setSelectedPlayersTeam,
        setIsConfirmMultipleChoice
    } = props;
    const decreaseMultiplePlayersInput = (key, currentPlayer) => {
        const selectedCount = selectedPlayersTeam[key] ? selectedPlayersTeam[key] : 0;
        if (selectedCount && selectedCount > 0) {
            const newMultiplePlayersSelectedList = { ...selectedPlayersTeam }
            newMultiplePlayersSelectedList[key] = selectedCount - 1
            
            setSelectedPlayersTeam(newMultiplePlayersSelectedList);
            if (selectedCount && selectedCount == 1 ) {
                setSelectedPlayers (selectedPlayers.filter((e) => e.key !== currentPlayer));
                if (Array.from(new Set(selectedPlayers.map(x=> x.key))).length === 1)
                {
                    setSelectedPlayersTeam({});
                    setIsConfirmMultipleChoice(false);  
                }
            }
        }
    }

    let multiplePlayersBar = useMemo(() => {
        if (selectedPlayers.length > 0) {
            const playersFlat = homeTeamPlayers.some(r => selectedPlayers.includes(r)) 
                ? homeTeamPlayers.map(x => ({ id: x.shirtNumber, key: x.key })) 
                : awayTeamPlayers.map(x => ({ id: x.shirtNumber, key: x.key }));
            let selectedPlayerKeys = Object.keys(selectedPlayersTeam).filter(x => x !== 'teamId');

            let totalClicks = 0;
            for (let i = 0; i < selectedPlayerKeys.filter(x => x !== 'teamId').length; i++) {
                let key = selectedPlayerKeys[i];
                totalClicks += selectedPlayersTeam[key];
            }

            let output = []

            for (let i = 0; i < selectedPlayerKeys.length; i++) {
                let key = selectedPlayerKeys[i];
                if (selectedPlayersTeam[key] > 0) {

                    let playersClicks = selectedPlayersTeam[key];

                    let widthPercentage = playersClicks / totalClicks * 100;

                    let matchedPlayers = playersFlat.find(x => x.id == key);
                    
                    let radiusMap = ['0', '0', '0', '0'];

                    if (i == 0) {
                        radiusMap[0] = '5px'
                        radiusMap[3] = '5px'
                    }

                    if (i == selectedPlayerKeys.length - 1) {
                        radiusMap[1] = '5px'
                        radiusMap[2] = '5px'
                    }

                    let radiusCssValue = `${radiusMap[0]} ${radiusMap[1]} ${radiusMap[2]} ${radiusMap[3]}`;

                    output.push(
                        <span key={key} style={{
                            width: `${widthPercentage}%`,
                            borderRadius: radiusCssValue
                        }} className='categorizationBarItem'>
                            <a onClick={(event) => { decreaseMultiplePlayersInput(key, matchedPlayers?.key) }} className='categorizationBarButton'>
                                {matchedPlayers.key} ({playersClicks})
                            </a>
                        </span>
                    )
                }
            }

            return <>
                <div className='categorizationBar'>
                    {output}
                </div>


            </>;
        } else {
            return <></>;
        }
    }, [selectedPlayersTeam]);

    return (
        <>
            <div
                className="d-flex flex-fill py-1"
                style={{ overflowX: "auto" }}
            >
                {multiplePlayersBar}
            </div>
        </>
    );
}

export default MultiplePlayersBar;
